import React from 'react'
import Home from './Home'
import Weoffering from '../We_offering/Weoffering'
import Second from '../Secondpage/Second'
import Final from '../Final/Final'
import Ribbon from '../ribbon/Ribbon'
import BankSection from '../BankSection/BankSection'
import Chat from '../Chat/Chat'

function Main() {

 
  return ( 
      <div className='bg-white min-h-screen  md:flex-row items-center justify-center '>
      <Home ></Home>
      <Ribbon></Ribbon>
      <Weoffering></Weoffering>
      <Second></Second>
      <BankSection></BankSection>
      <Chat></Chat>
      <Final></Final>
     
    </div>
  )
}


export default Main